module.exports = __webpack_public_path__ + "img/banner3.eaf05863.png";